import type { ReactNode } from "react";
import { cn } from "../lib/cn";

export type StatusTone = "success" | "warning" | "error" | "info" | "pending";

const STATUS_DOT_CLASSES: Record<StatusTone, string> = {
	success: "bg-statusSuccess",
	warning: "bg-statusWarning",
	error: "bg-destructive",
	info: "bg-statusInfo",
	pending: "bg-mutedForeground",
};

const STATUS_TONE_LABELS: Record<StatusTone, string> = {
	success: "Success",
	warning: "Warning",
	error: "Error",
	info: "Info",
	pending: "Pending",
};

export interface StatusIndicatorProps {
	status: StatusTone;
	label?: string;
	className?: string;
}

function StatusIndicator({
	status,
	label,
	className,
}: StatusIndicatorProps): ReactNode {
	return (
		<span
			className={cn("inline-flex items-center gap-1.5", className)}
			aria-label={label ?? STATUS_TONE_LABELS[status]}
		>
			<span
				className={cn(
					"h-2 w-2 shrink-0 rounded-full",
					STATUS_DOT_CLASSES[status],
				)}
				aria-hidden="true"
			/>
			{label && <span className="text-sm text-foreground">{label}</span>}
		</span>
	);
}
StatusIndicator.displayName = "StatusIndicator";

export default StatusIndicator;
export { StatusIndicator };
